import _ from 'lodash'

import { Mutation as VuexMutation, MutationTree } from 'vuex'
import { AvailableDate, Booking, ModuleState } from './types'

export interface SetAvailableDatesMutation {
  type: 'setAvailableDates'
  dates: AvailableDate[]
}

export interface SetBookingsMutation {
  type: 'setBookings'
  bookings: Booking[]
}

export interface ResetAllMutation {
  type: 'resetAll' | 'interview/bookings/resetAll'
}

const setAvailableDates: VuexMutation<ModuleState> = (
  state,
  { dates }: SetAvailableDatesMutation
) => {
  state.availableDates = dates
}

const setBookings: VuexMutation<ModuleState> = (
  state,
  { bookings }: SetBookingsMutation
) => {
  state.bookings = bookings
}

const resetAll: VuexMutation<ModuleState> = state => {
  Object.keys(state.subscriptions).forEach(key => {
    const subscription = state.subscriptions[key]
    if (subscription && !subscription.closed) {
      subscription.unsubscribe()
    }
  })
  state.subscriptions = {}
  state.availableDates = []
  state.bookings = []
}

export type Mutation =
  | SetAvailableDatesMutation
  | SetBookingsMutation
  | ResetAllMutation

export const mutations: MutationTree<ModuleState> = {
  resetAll,
  setAvailableDates,
  setBookings,
}

export default mutations
